import { AssetTypeModel } from '../../asset/components/model/asset-type.model';
import { MakeModel } from '../../make/model/make.model';

export class ProductModel {
  averageProfit: number;
  capacity: number;
  createdBy: string;
  createdDate: Date;
  description: string;
  equipmentType: string;
  endDate: Date;
  id: number;
  isExpense: boolean;
  isOrderable: boolean;
  isOriginalEquipment: boolean;
  isSalesProduct: boolean;
  isServiceProduct: boolean;
  jobCode: string;
  makeId: number;
  model: string;
  name: string;
  partNumber: string;
  priceCodeId: string;
  productType: string;
  sku: string;
  startDate: Date;
  type: string;
  typeId: number;
  updatedBy: string;
  updatedDate: Date;
  vendorCost: number;
  vendorId: string;
  vendorName: string;
  requiresAudit = false;
  isActive = true;
  laborInformation?: LaborInformation;
  make: MakeModel;
  assetTypeId: number;
  assetType: AssetTypeModel;
  productKeyword: ProductKeyword;

  constructor() {
    this.laborInformation = new LaborInformation();
    this.productKeyword = new ProductKeyword();
  }
}

export class LaborInformation {
  maximumMaterialCost: number;
  minimumMaterialCost: number;
  isTruckStock: boolean;
  isDisplayedOnLaborInformationPortal: boolean;
}

export class PartAndProductModelUtil {
  public static getLaborInformationModelToCreate(
    productModel: ProductModel,
    productId: string
  ): any {
    let model: any = { ...productModel.laborInformation };
    model.productId = productId;
    return model;
  }
}

export class ProductKeyword {
  id: number;
  productId: number;
  keyword: string;
}
